// extracted by mini-css-extract-plugin
export default {"brand":"FaqModal_brand__w3oP5","question":"FaqModal_question__wDfIp","answer":"FaqModal_answer__dq9v3"};